/**
 * Единственный источник расчёта прогресса проекта на клиенте.
 * Прогресс = среднее по чтецам (reader_progress из project_readers).
 */
export function computeProjectProgress(project: { readers?: { progress?: number }[] }): number {
  const readers = project.readers ?? [];
  if (readers.length === 0) return 0;
  const sum = readers.reduce((s, r) => s + (r.progress ?? 0), 0);
  return Math.min(100, Math.max(0, Math.floor(sum / readers.length)));
}
